import React from "react";

export default class Disagreement extends React.Component {
  state = {
    value: null,
  };
  render() {
    const { Bs, SIZE, VARIANT, hideDisagreement, sent, alert, loading } = this.props;
    return (
      <>
        <Bs
          modal
          show={true}
          onHide={hideDisagreement}
          keyboard={true}
          backdrop="static"
          centered
          size={SIZE.LG}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>
            Vytvořit neshodu
          </Bs>
          {alert && (
            <Bs alert variant={VARIANT.DANGER}>
              {alert}
            </Bs>
          )}

          <Bs modalbody>
            <Bs row>
              <Bs col xs={12}>
                <Bs
                  formcontrol
                  value={this.state.value}
                  onChange={(e) => this.setState({ value: e.target.value })}
                  type="text"
                  as="textarea"
                  rows="15"
                />
              </Bs>
            </Bs>
            <Bs row className="mt-2">
              <Bs col xs={12} className="d-flex justify-content-end">
                <Bs
                  button
                  variant={VARIANT.SUCCESS}
                  size={SIZE.SM}
                  disabled={loading}
                  onClick={() => sent(this.state.value)}
                >
                    {loading ? <Bs brtxspin /> : "Odeslat"}
                  
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}
